export default {
  common: {
    loading: 'ဖတ်နေသည်',
    confirm: 'အတည်ပြုရန်',
    cancel: 'ဖျက်သိမ်းရန်',
    save: 'သိမ်းမည်',
    back: 'ပြန်သွားရန်',
    copy: 'ကူးယူမည်',
    delete: 'ဖျက်မည်',
    copySuccess: 'ကူးယူပြီးပါပြီ',
    editSuccess: 'တည်းဖြတ်မှုအောင်မြင်သည်',
    deleteSuccess: 'ဖျက်ခြင်းအောင်မြင်သည်',
    modifySuccess: 'ပြုပြင်မှုအောင်မြင်သည်',
    cannotBeEmpty: 'ဗလာမထားရ',
    noContent: 'အကြောင်းအရာမရှိပါ',
    noData: 'သက်ဆိုင်သောဒေတာမရှိပါ',
    noMoreData: 'နောက်ထပ်ဒေတာမရှိပါ',
    iKnow: 'သိပြီ',
    selectService: 'ဝန်ဆောင်မှုပေးသူရွေးပါ',
    sendSuccess: 'ပို့အောင်မြင်',
  },
  billHome: {
    recharge: 'ငွေဖြည့်/ငွေပေးချေမှု',
    coupon: 'ကူပွန်',
    rechargeNow: 'အခုဘဲ ဖြည့်ပါ',
    cost: 'ဖုန်းခ',
    flow: 'အင်တာနက်',
    rechargeNotice: 'ဖြည့်ခြင်းမပြုမီသိရန်',
    rechargeCost: 'ဖုန်းခ ဖြည့်ခြင်း',
    rechargeFlow: 'အင်တာနက်ဖြည့်ခြင်း',
    rechargeAmount: 'ဖြည့်သွင်းငွေပမာဏ',
    rechargePackage: 'ဖြည့်သွင်းခြင်းအထုပ်',
    discount: 'လျှော့စျေးအသုံးပြုထားသည်',
    confirmTxt: 'မှန်ကန်ကြောင်းအတည်ပြုပါ',
    confirmTxt1: 'နားလည်ပါပြီ',
    actualPayment: 'အမှန်ပေးရန်',
    selectCoupon: 'ကူပွန်ရွေးပါ',
    useRule: 'သုံးစွဲခြင်းစည်းကမ်းများ',
    availableCoupon: 'အသုံးပြုနိုင်သောကူပွန်',
    unavailableCoupon: 'အသုံးမပြုနိုင်သောကူပွန်',
    noAvailableCoupon: 'အသုံးပြုနိုင်သောကူပွန်မရှိပါ',
    selectPhone: 'ဖုန်းနံပါတ်ရွေးပါ',
    pleaseInputPhone: 'ဖုန်းနံပါတ် ထည့်ပါ',
    couponCount: 'သုံးနိုင်သောကူပွန်',
    pleaseInputCorrectPhone: 'မှန်ကန်သောဖုန်းနံပါတ်ကိုထည့်သွင်းပါ',
    pleaseSelectPackage: 'ဖြည့်သွင်းငွေပက်ကေ့ချ်ကိုရွေးချယ်ပါ',
  },
  accountManage: {
    title: 'အကောင့်စီမံမှု',
    edit: 'တည်းဖြတ်ရန်',
    deleteConfirm: 'ဖျက်ရန်အတည်ပြုပါ',
  },
  rechargeDetail: {
    title: 'ငွေပေးချေမှုအသေးစိတ်',
    continuePay: 'ဆက်လက်ပေးချေမည်',
  },
  feesExpense: {
    title: 'ငွေပေးချေမှတ်တမ်း',
    recharge: 'ဖုန်းနံပါတ်',
    electricity: 'လျှပ်စစ်ခ',
    internet: 'အင်တာနက်',
    water: 'ရေ',
    photo: 'ဓာတ်ပုံ',
    complete: 'ပြီးဆုံးသည်',
    manage: 'စီမံရန်',
    allSelect: 'အားလုံးရွေးပါ',
    selected: 'ရွေးထားသည်',
    deleteConfirm: '',
    deleteRecord: 'ဤမှတ်တမ်းကိုဖျက်မည်လား?',
    noDataAction: 'အလုပ်လုပ်နိုင်သောဒေတာမရှိပါ',
    pleaseSelect: 'ဖျက်မည့်မှတ်တမ်းရွေးပါ',
    feesNotice: 'ပေးချေရန်မတိုင်ခင်သိထားသင့်သည်',
  },
  formCom: {
    upload: 'အပ်လုဒ်ရန်နှိပ်ပါ',
    saveAccount: 'အကောင့်သိမ်းမည် သို့မဟုတ် ပြင်မည်',
    createOrder: 'အော်ဒါတင်မည်',
    rechargeIng: 'ငွေဖြည့်နေသည်',
    rechargeNow: 'အခုဘဲ ဖြည့်မည်',
    serviceProvider: 'ဝန်ဆောင်မှုပေးသူ',
    billImage: 'ငွေတောင်းလွှာပုံ',
    returnSelect: 'ပြန်သွားပြီးထပ်မံရွေးပါ',
    electricity: 'မီတာဖိုးပေးချေခြင်း',
    internet: 'အင်တာနက်ကြေး',
    water: 'ရေဖိုး',
    photo: 'ဓာတ်ပုံဖြင့်ပေးချေခြင်း',
    life: 'နေ့စဉ်အသုံးပေးချေမှု',
    uploadFail: 'အပ်လုဒ်မအောင်မြင်ပါ။ ထပ်မံကြိုးစားပါ',
    pleaseFill: 'အချက်အလက်အားလုံးဖြည့်ပါ',
    submitSuccess: 'တင်ပြပြီးပါပြီ။ ငွေပေးချေမှုအတွက်စောင့်ပါ',
  },
  langPop: {
    selectLang: 'ဘာသာစကားရွေးပါ',
  },
  loginPop: {
    loginOrRegister: 'Kuaizi အကောင့်ဖြင့် Login သို့မဟုတ် Register ပြုလုပ်ပါ',
    confirmLogout: 'Logout ပြုလုပ်မည်မှာ သေချာပြီလား?',
    toLogin: 'Login မည်',
    logoutSuccess: 'Logout အောင်မြင်ပါသည်',
  },
  newMe: {
    myOrder: 'ကျွန်ုပ်၏အော်ဒါများ',
    coupon: 'ကူပွန်',
    accountManage: 'အကောင့်စီမံခြင်း',
    orderCount: 'အော်ဒါများဆောင်ရွက်ဆဲ',
    couponCount: 'ခု',
    account: 'အကောင့်',
    logout: 'Logout',
  },
  coupons: {
    all: 'အားလုံး',
    coupon: 'ကူပွန်',
    historyCoupon: 'သုံးပြီး/သက်တမ်းကုန်ကူပွန်များ',
    use: 'အသုံးပြုမည်',
    validityPeriod: 'သက်တမ်း',
    useRule: 'အသုံးပြုစည်းကမ်း',
    used: 'သုံးပြီး',
    expired: 'သက်တမ်းကုန်',
  },
  accountSeting: {
    title: 'ဆက်တင်များ',
    personalInfo: 'ကိုယ်ရေးအချက်အလက်',
    modifyPayPassword: 'ငွေပေးချေမှု စကားဝှက်ပြောင်းရန်',
    modifyLoginPassword: 'Login စကားဝှက်ပြောင်းရန်',
    phone: 'ဖုန်းနံပါတ်',
    code: 'အတည်ပြုကုဒ်',
    loginPassword: 'Login စကားဝှက်',
    confirmModify: 'ပြောင်းရန်အတည်ပြုပါ',
    noCode: 'ကုဒ်မရလား?',
    passwordPlaceholder: 'စာလုံးနဲ့နံပါတ် ပါဝင်သော 8–16 လုံး',
    inputCorrectPhone: 'မှန်ကန်သောဖုန်းနံပါတ်ထည့်ပါ',
    afterGetCode: 'နောက်တစ်ကြိမ်ထပ်မံယူနိုင်သည်',
    getCode: 'ကုဒ်ယူမည်',
    input6DigitPassword: '၆ လုံးစာ စကားဝှက်ထည့်ပါ',
    twoInputPasswordNotConsistent: 'စကားဝှက် ၂ ခါ မတူပါ',
    placeholderCode: 'အတည်ပြုကုဒ်ထည့်ပါ',
    confirmPassword: 'စကားဝှက်အတည်ပြုပါ',
    password: 'စကားဝှက်',
    submit: 'တင်သွင်းမည်',
    avatar: 'ပရိုဖိုင်ပုံ',
    userName: 'အသုံးပြုသူအမည်',
    nickName: 'အတိုအဖြတ်အမည်',
    modifyPhone: 'ဖုန်းနံပါတ်ပြောင်းရန်',
    nickNamePlaceholder: 'သင်၏ကိုယ်ပိုင်ပုံစံကိုဖော်ပြပါ',
    sex: 'လိင်',
    male: 'အထီး',
    female: 'အမြား',
    email: 'အီးမေးလ်',
    emailPlaceholder: 'စကားဝှက်မေ့ပါကပြန်ယူရန်အီးမေးလ်ထည့်ပါ',
    pleaseCompletePersonalData: 'ပိုပြီးလုပ်ဆောင်နိုင်ရန် ကိုယ်ရေးအချက်အလက် ဖြည့်ပါ',
    bindNewPhone: 'ဖုန်းနံပါတ်အသစ် ချိတ်ဆက်ပါ',
    oldPhone: 'အဟောင်းဖုန်း',
    completeVerification: 'အတည်ပြုခြင်း ပြီးပါပြီ',
    changePayPasswordTitle: 'ငွေပေးချေမှု စကားဝှက်ပြောင်းပါ',
    changePasswordTitle: 'စကားဝှက်ပြောင်းပါ',
    oldPhoneTitle: 'အဟောင်းဖုန်း အတည်ပြုပါ',
    editInfoTitle: 'ကိုယ်ရေးအချက်အလက် ပြင်ဆင်ပါ',
    areaCode: 'နယ်ကုဒ်',
  },
}
